import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Introduction from "../components/home/Introduction";
import PageWrapper from "../components/common/layout/PageWrapper";
import {
  AsyncCallArgs,
  CircularLoader,
  CONTENT_MANAGEMENT_ID,
  GridSpg,
  isArrayNotEmpty,
  useAsyncCall,
} from "@duosoftbg/nacid-components";
import PublicGlobalMessages from "./publicMessages/PublicGlobalMessages";
import CategoryWrapper from "../components/home/category/CategoryWrapper";
import CategoryTile from "../components/home/category/CategoryTile";
import CategoryLink from "../components/home/category/CategoryTileLink";
import { ReactComponent as ReportsLogo } from "@duosoftbg/nacid-components/dist/assets/images/icon-Reports.svg";
import { ReactComponent as LibservLogo } from "@duosoftbg/nacid-components/dist/assets/images/icon-Book.svg";
import { ReactComponent as ApostilleLogo } from "@duosoftbg/nacid-components/dist/assets/images/icon-Stamp.svg";
import { ReactComponent as CertificatesLogo } from "@duosoftbg/nacid-components/dist/assets/images/icon-Pen.svg";
import { ReactComponent as AcademicRecognitionLogo } from "@duosoftbg/nacid-components/dist/assets/images/icon-Diploma.svg";
import { ReactComponent as CommonServicesLogo } from "@duosoftbg/nacid-components/dist/assets/images/icon-EasyAccess.svg";
import { ReactComponent as RegistersLogo } from "@duosoftbg/nacid-components/dist/assets/images/icon-Registers.svg";
import { ReactComponent as ImpactFactorLogo } from "@duosoftbg/nacid-components/dist/assets/images/icon-Impact-Factor.svg";
import { ReactComponent as ProfQualificationLogo } from "@duosoftbg/nacid-components/dist/assets/images/icon-Prof-Qual.svg";
import { getContentManagementDataById } from "../../axios/api/services";

import { homePageCategoryIcons } from "../../utils/constants";

const HomePage = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const { asyncCall } = useAsyncCall();

  useEffect(() => {
    const asyncCallArgs: AsyncCallArgs = {
      promise: getContentManagementDataById(CONTENT_MANAGEMENT_ID.HOME_PAGE_CATEGORY_CONTROL),
      onSuccess: (response) => {
        setCategories(response);
        setLoading(false);
        setError(false);
      },
      onError: () => {
        setError(true);
        setLoading(false);
      },
    };
    asyncCall(asyncCallArgs);
  }, [asyncCall]);
  return <>{<Content categories={categories} loading={loading} error={error} />}</>;
};

const Content = ({ categories, loading, error }) => {
  const { t } = useTranslation();
  const findIcon = (icon) => {
    if (icon) {
      switch (icon) {
        case homePageCategoryIcons.reportsLogo:
          return <ReportsLogo />;
        case homePageCategoryIcons.libraryServicesLogo:
          return <LibservLogo />;
        case homePageCategoryIcons.apostilleLogo:
          return <ApostilleLogo />;
        case homePageCategoryIcons.certificatesLogo:
          return <CertificatesLogo />;
        case homePageCategoryIcons.academicRecognitionLogo:
          return <AcademicRecognitionLogo />;
        case homePageCategoryIcons.registersLogo:
          return <RegistersLogo />;
        case homePageCategoryIcons.commonServicesLogo:
          return <CommonServicesLogo />;
        case homePageCategoryIcons.impactFactorLogo:
          return <ImpactFactorLogo />;
        case homePageCategoryIcons.profQualificationLogo:
          return <ProfQualificationLogo />;
        default:
          return null;
      }
    }
    return null;
  };
  return (
    <>
      <Introduction />
      <PageWrapper centerTitle helmetTitle={t("t.page.homePage")}>
        <GridSpg container spacing={10}>
          <GridSpg item xs={12} sm={12} md={12} lg={12}>
            <PublicGlobalMessages />
          </GridSpg>
        </GridSpg>

        {loading && <CircularLoader mt={20} />}

        {!loading && !error && (
          <CategoryWrapper>
            <GridSpg item xs={12} sm={12} md={12} lg={12}></GridSpg>
            {isArrayNotEmpty(categories) &&
              categories.map((category) => (
                <CategoryTile key={category.id} svgIconComponent={findIcon(category.icon)} category={category}>
                  {isArrayNotEmpty(category.links) &&
                    category.links.map((link) => <CategoryLink key={link.id} link={link} />)}
                </CategoryTile>
              ))}
          </CategoryWrapper>
        )}
      </PageWrapper>
    </>
  );
};

export default HomePage;
